import { Box, Container, Stack, Typography } from '@mui/material';
import React from 'react';
import './styles.scss';

const Header = () => {
  return (
    <Box
      component="header"
      role="banner"
      className="main-banner" // mantiene tu fondo desde SCSS
      sx={{ position: 'relative', zIndex: 0 }}
      aria-labelledby="hero-heading"
    >
      {/* Overlay para contraste */}
      <Box
        aria-hidden
        sx={{
          position: 'absolute',
          inset: 0,
          background:
            'linear-gradient(to bottom, rgba(0,0,0,.35), rgba(0,0,0,.45))',
        }}
      />

      <Container
        maxWidth="lg"
        sx={{
          position: 'relative',
          minHeight: { xs: '50vh', md: '60vh' },
          display: 'grid',
          placeItems: 'center',
          py: { xs: 0, md: 4.5 },
          textAlign: 'center',
        }}
      >
        <Stack spacing={1} alignItems="center">
          <Box
            component="img"
            src="/assets/logos/logohorizontal.png"
            alt="Laboratorio Sertex (logo)"
            loading="eager"
            fetchpriority="high"
            sx={{
              width: { xs: 200, sm: 280, md: 360 },
              height: 'auto',
              objectFit: 'contain',
            }}
          />

          <Typography
            id="hero-heading"
            variant="h1"
            component="h1"
            sx={{
              fontWeight: 600,
              color: '#fff',
              letterSpacing: 0.5,
              fontSize: { xs: '1.25rem', sm: '1.75rem', md: '2.25rem' },
              maxWidth: 960,
              px: { xs: 2, md: 8 },
            }}
          >
            SERTEX asume la responsabilidad de crecer y desarrollarse haciendo
            foco en la calidad de sus productos y la satisfacción del cliente,
            respetando las normas sanitarias y la ética profesional.
          </Typography>

          {/* CTAs opcionales */}
          {/* 
          <Stack direction="row" spacing={2}>
            <Button variant="contained" color="secondary" size="large" href="#Productos">
              Ver productos
            </Button>
            <Button variant="outlined" color="inherit" size="large" href="#Contacto">
              Contacto
            </Button>
          </Stack>
          */}
        </Stack>
      </Container>
    </Box>
  );
};

export default Header;
